export default __webpack_public_path__ + "static/media/77-min.9c98873a.jpg";